import { render } from "./TenantBrandSurface.vue?vue&type=template&id=ae1775d8&scoped=true"
import script from "./TenantBrandSurface.vue?vue&type=script&lang=js"
export * from "./TenantBrandSurface.vue?vue&type=script&lang=js"

import "./TenantBrandSurface.vue?vue&type=style&index=0&id=ae1775d8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae1775d8"]])

export default __exports__